export enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",

    INCREASED_BY_MORE_THAN = 'INCREASED_BY_MORE_THAN',
    INCREASED_BY_MORE_THAN_EQUAL = 'INCREASED_BY_MORE_THAN_EQUAL',
    INCREASED_BY_LESS_THAN = 'INCREASED_BY_LESS_THAN',
    INCREASED_BY_LESS_THAN_EQUAL = 'INCREASED_BY_LESS_THAN_EQUAL',

    DECREASED_BY_MORE_THAN = 'DECREASED_BY_MORE_THAN',
    DECREASED_BY_MORE_THAN_EQUAL = 'DECREASED_BY_MORE_THAN_EQUAL',
    DECREASED_BY_LESS_THAN = 'DECREASED_BY_LESS_THAN',
    DECREASED_BY_LESS_THAN_EQUAL = 'DECREASED_BY_LESS_THAN_EQUAL',

    MORE_THAN = 'MORE_THAN',
    MORE_THAN_EQUAL = 'MORE_THAN_EQUAL',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',

}
